
import { DamageType, EffectType } from "@dndModels/Types";
import {
  DiceRoll
} from "@dndModels/misc/DiceRoll";

export class RollPlus extends DiceRoll {
  flat: number;
  ability_score: string;
  as_string: string;
  type: EffectType | DamageType | "Attack" | "Recharge";

  constructor(obj?: any) {
    super(obj);
    this.flat = obj && obj.flat ? +obj.flat : 0;
    this.ability_score = obj && obj.ability_score ? obj.ability_score : "";
    this.type = obj && obj.type ? obj.type : "None";
    this.as_string = "";
    if (this.flat === 0 && this.size === 1 && this.count !== 0) {
      this.flat = this.count;
      this.count = 0;
    }
    this.recalculate_string();
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      size: this.size,
      count: this.count,
      flat: this.flat,
      ability_score: this.ability_score,
      type: this.type
    };
  }

  recalculate_string(include_bonus = true) {
    let the_string = "";
    let the_bonus = 0;
    the_bonus += +this.flat;
    if (this.count !== 0) {
      if (this.size === 1) {
        the_bonus += +this.count;
      } else {
        the_string += `${this.count}d${this.size}`;
      }
    }
    if (include_bonus) {
      if (the_bonus > 0 && the_string.length > 0) {
        the_string += `+${the_bonus}`;
      } else if (the_bonus !== 0) {
        the_string += `${the_bonus}`;
      }
    }
    this.as_string = the_string;
  }

  copy(copyMe: RollPlus, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.flat = copyMe.flat;
    this.ability_score = copyMe.ability_score;
    this.type = copyMe.type;
    this.as_string = "";
    this.recalculate_string();
  }

  clone(drop_ids = false): RollPlus {
    const new_obj = new RollPlus();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  clean() {
    if (this.size === 1) {
      this.flat += this.count;
      this.count = 0;
      this.size = 0;
    } else {
      super.clean();
    }
  }

  isFlat() {
    this.clean();
    return this.size === 0;
  }
}

export interface RolledValue {
  type: string;
  count: number;
  size: number;
  flat: number;
  advantage: number;
  roll_values: RollValue[];
}

export interface RollValue {
  main_values: number[]; // If ADV/DISADV, then this will have more than 1.
  rerolled: boolean; 
  reroll_value?: number; // If rerolled, then this holds the rerolled value.
  minrolled: boolean;
  minroll_value?: number; // If minrolled, then this holds the minrolled value
}